<template>
  <wh-popup
    v-model="myVisible"
    title="产品信息"
    :ref-form="$refs.ProductPopup"
    @close="hidePopup"
    @open="open"
  >
    <van-form
      ref="ProductPopup"
      class="product-popup"
      label-width="60px"
      @submit="submitForm"
    >
      <div class="img">
        <wh-upload v-model="form.productPhoto" :size="140" class="upload" :max-count="1" />
      </div>
      <div class="list">
        <van-cell title="产品名称" :value="form.productName" is-link @click="editName(form.productName)" />
        <van-cell title="包装规格" :value="unit" is-link @click="$toast('此处包装规格不能修改')" />
        <van-cell title="包装时间" :value="formatTime(form.packingTime,'YYYY-MM-DD')" is-link @click="$toast('此处包装时间不能修改')" />
      </div>
    </van-form>
    <van-dialog
      v-model="dialog.edit.visible"
      data-name="产品名称"
      title="产品名称"
      show-cancel-button
      @confirm="form.productName = dialog.edit.name"
    >
      <div class="dialog-input">
        <van-field v-model="dialog.edit.name" border :clearable="true" placeholder="请输入产品名称" />
      </div>
    </van-dialog>
  </wh-popup>
</template>
<script>
import WhUpload from '@/components/public/WhUpload/WhUpload'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { formatTime } from '@/utils/convert/convertTime'
import { formPopup } from '@/utils/mixins/formPopup'
export default {
  components: { WhPopup, WhUpload },
  mixins: [formPopup],
  data() {
    return {
      dialog: {
        edit: {
          visible: false,
          name: ''
        }
      },
      form: {
        productName: '',
        productPhoto: [],
        specificationPacking: '',
        specificationQuantity: '',
        specificationUint: '',
        packingTime: ''
      }
    }
  },
  computed: {
    unit() {
      return `${this.form.specificationQuantity}${this.form.specificationUint}/${this.form.specificationPacking}`
    }
  },
  methods: {
    formatTime,
    open() {
      this.formDataInit(this.form, this.initFormData)
    },
    submitForm() {
      this.$emit('confirm', this.form)
      this.hidePopup()
    },
    editName(i) {
      this.dialog.edit.visible = true
      this.dialog.edit.name = i
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .van-cell.van-field {
  padding: 6px;
  border: 2px solid #ccc;
  border-radius: 6px;
}
.product-popup{
  padding: 10px 16px;
  .img{
    height: 240px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .list{
    padding-top: 20px;
  }
}
  .dialog-input{
    margin: 0 20px;
  }
</style>
